<payee-popup
  id="missing-ref-id-popup"
  title="Számla kiválasztása"
  [onCancel]="close"
  [onSubmit]="submit"
>
  <div
    class="flex"
    id="missing-ref-id-container"
  >
    <ul
      id="missing-ref-id-data"
      class="grow1"
    >
      <h2>Követelés</h2>
      <li>
        Fennálló követelés: {{ data.remaining_amount | number: "1.0" : "hu" }}
        {{ data.currency_iso }}
      </li>
      <li>
        Teljes követelés: {{ data.original_amount | number: "1.0" : "hu" }}
        {{ data.currency_iso }}
      </li>
      <li>Fizetési határidő: {{ data.due_date_at | date: "yyyy.MM.dd." }}</li>
      <li>Követelés fájl neve: {{ data.invoice_file_name }}</li>
      <li>Követelés utolsó frissítése: {{ data.updated_at | date: "yyyy.MM.dd." }}</li>
      <li>Követelés létrehozva: {{ data.created_at | date: "yyyy.MM.dd." }}</li>
      <li>Követelés UUID: {{ data.uuid }}</li>
    </ul>
    <ul
      id="missing-ref-id-selected"
      class="grow1"
    >
      <h2>Kiválasztott számla</h2>
      <li>
        Fennálló követelés:
        {{ selectedInvoice?.remaining_amount | number: "1.0" : "hu" }}
        {{ selectedInvoice?.currency_iso }}
      </li>
      <li>
        Teljes követelés:
        {{ selectedInvoice?.original_amount | number: "1.0" : "hu" }}
        {{ selectedInvoice?.currency_iso }}
      </li>
      <li>
        Fizetési határidő:
        {{ selectedInvoice?.due_date_at | date: "yyyy.MM.dd." }}
      </li>
      <li>Számla neve: {{ selectedInvoice?.invoice_number }}</li>
    </ul>
  </div>

  <table
    id="missing-ref-id-invoice-table"
    mat-table
    matSort
    class="mat-elevation-z1"
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="remaining_amount">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Fennálló követelés
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.remaining_amount | number: "1.0" : "hu" }}
        {{ element.currency_iso }}
      </td>
    </ng-container>

    <ng-container matColumnDef="original_amount">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Teljes követelés
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.original_amount | number: "1.0" : "hu" }}
        {{ element.currency_iso }}
      </td>
    </ng-container>

    <ng-container matColumnDef="due_date_at">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Fizetési határidő
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.due_date_at | date: "yyyy.MM.dd." }}
      </td>
    </ng-container>

    <ng-container matColumnDef="invoice_number">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        invoice_number
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.invoice_number }}
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Kiválasztás
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <mat-radio-button
          [checked]="element.id === selectedInvoice?.id"
          (change)="selectInvoice(element)"
        ></mat-radio-button>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let row; columns: displayedColumns"
      mat-row
    ></tr>
  </table>
  <mat-paginator
    id="missing-ref-id-invoice-paginator"
    pageSize="5"
    showFirstLastButtons
  ></mat-paginator>
</payee-popup>
